$(document).ready(function () {
    try {
        prepareForm(form);
    } catch(e) {}
});


function prepareForm(form)
{

    // ------------------------------------------------------------------------------------
    // Form options
    // ------------------------------------------------------------------------------------

    if(typeof(form['required']) == "object") {

        $.each(form['required'], function (key, field) {
            $('#' + field).prop('required', 'required');
        });

        $.each(form['required'], function (key, field) {
            $("[name='"+field+"']").prop('required', 'required');
        });

    }

    // ------------------------------------------------------------------------------------

    if(typeof(form['placeholder']) == "object") {

        $.each(form['placeholder'], function (key, value) {
            $('#' + key).prop('placeholder', value);
        });

    }

    // ------------------------------------------------------------------------------------

    if(typeof(form['pattern']) == "object") {

        $.each(form['pattern'], function (key, value) {
            $('#' + key).prop('pattern', value);
        });

    }

    // ------------------------------------------------------------------------------------
    // Pattern
    // ------------------------------------------------------------------------------------

    $('.real').prop('pattern', '[-+]?[0-9]*[.]?[0-9]+');
    $('.decimal').prop('pattern', '[-+]?[0-9]*[,]?[0-9]+');
    $('.email').prop('pattern', '[-+]?[0-9]*[.]?[0-9]+');

    // ------------------------------------------------------------------------------------
    // Form mask
    // ------------------------------------------------------------------------------------

    $('.cpf').mask("000.000.000-00");
    $('.cpf').prop('placeholder', '___.___.___-__');

    // ------------------------------------------------------------------------------------


    $('.cep').mask("00000-000");
    $('.cep').prop('placeholder', '_____-___');

    // ------------------------------------------------------------------------------------

    $('.data').mask("00/00/0000");
    $('.data').prop('placeholder', '__/__/____');

    $('.hora').mask("00:00");
    $('.hora').prop('placeholder', '__:__');

    // ------------------------------------------------------------------------------------

    $('.fone').mask("(00) 0000-00009");
    $('.fone').prop('placeholder', '(__) ____-_____');

    // ------------------------------------------------------------------------------------

    $('.decimal1').mask("0.0");
    $('.decimal1').prop('placeholder', '_._');

    $("#tab4 #numero").mask("09999999").prop('placeholder', '________');

    $('.nota-enem').prop({'placeholder': "Valor entre 0 e 1000" });
}


/**
 * options = {
 *      obj: $(...),
 *      objPai: $(...).parent(),
 *      msgAjuda: 'Campo Obrigatório'
 *
 * @param options
 * @returns {boolean}
 */
function validarCampo(optionsParams) {

    if (!optionsParams || !optionsParams.obj) {
        return false;
    }

    var options = {
        obj: null,
        objPai: null,
        msgAjuda: 'Campo Obrigatório'
    };

    $.extend(options, optionsParams);

    if (!options.objPai) {
        options.objPai = options.obj.parent();
    }

    // Verifica se todos os campos obrigatórios da etapa foram preenchidos
    var ok = true;
    var type = options.obj.attr('type');
    var valor = options.obj.val();

    if(type == 'checkbox' || type == "radio") {
        valor = options.obj.filter(':checked').val();
    }

    if(!valor) {
        ok = false;
        if(options.objPai && !options.objPai.is('.has-error')) {
            options.objPai.addClass('has-error').append('<div class="help-block">' + options.msgAjuda + '</div>');
        }
    } else if (valor && options.objPai && options.objPai.is('.has-error')) {
        options.objPai.removeClass('has-error').find('.help-block').remove();
    }

    return ok;
}